<template>
  <span class="svg-icon-more">
    <svg class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.25 21.875C16.25 23.1186 15.2436 24.125 14 24.125C12.7564 24.125 11.75 23.1186 11.75 21.875C11.75 20.6314 12.7564 19.625 14 19.625C15.2436 19.625 16.25 20.6314 16.25 21.875Z" :fill="color"/>
      <path d="M16.25 6.125C16.25 7.36864 15.2436 8.375 14 8.375C12.7564 8.375 11.75 7.36864 11.75 6.125C11.75 4.88136 12.7564 3.875 14 3.875C15.2436 3.875 16.25 4.88136 16.25 6.125Z" :fill="color"/>
      <path d="M16.25 14C16.25 15.2436 15.2436 16.25 14 16.25C12.7564 16.25 11.75 15.2436 11.75 14C11.75 12.7564 12.7564 11.75 14 11.75C15.2436 11.75 16.25 12.7564 16.25 14Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 28 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#fff' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>